import {
  WSForm,
  WSInputMask,
  WSInputText
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import {
  getTaxIdDescription,
  getTaxIdLabel,
  getTaxIdMask,
  getTaxIdPlaceholder
} from "../../../shared/utils/taxId";
import { EntityType } from "../types";

export type FormData = {};

type Props = {
  type: EntityType;
  country: string;
  name: string;
  requireTaxId?: boolean;
  mismatch?: boolean;
  disabled?: boolean;
};

export const FormPartialTaxId: React.FC<Props> = props => {
  const label = useMemo(
    () => getTaxIdLabel(props.type, props.country),
    [props.type, props.country]
  );

  const helperText = useMemo(
    () => getTaxIdDescription(props.type, props.country),
    [props.type, props.country]
  );

  const placeholder = useMemo(
    () => getTaxIdPlaceholder(props.type, props.country),
    [props.type, props.country]
  );

  const mask = useMemo(
    () => getTaxIdMask(props.type, props.country),
    [props.type, props.country]
  );

  const mismatchProps = props.mismatch
    ? ({
        status: "warning",
        message: "Mismatched info"
      } as const)
    : {};

  if (props.country === "US" || props.country === "CA") {
    return (
      <WSForm.Field
        key={props.country + "-tax-id"}
        name={props.name}
        label={label + (props.requireTaxId ? "" : " (optional)")}
        component={WSInputMask}
        componentProps={{
          disabled: props.disabled,
          required: props.requireTaxId,
          placeholder,
          helperText,
          mask,
          unmask: true,
          fsExclude: true,
          ...mismatchProps
        }}
      />
    );
  }

  return (
    <WSForm.Field
      key={props.country + "-tax-id"}
      name={props.name}
      label={label + (props.requireTaxId ? "" : " (optional)")}
      component={WSInputText}
      componentProps={{
        disabled: props.disabled,
        required: props.requireTaxId,
        fsExclude: true,
        placeholder,
        helperText,
        ...mismatchProps
      }}
    />
  );
};
